import { useDispatch, useSelector } from "react-redux";
import { ApiStatus } from "../types/api/status";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { changeStatusAlliaces, onChangeIsEdit, onFetchAlliances, onFetchRegions, onSetEditAlliance, onSetOpenModal, onSetSelectedAlliance, onSetSelectedRegion, selectAllianceState } from "../redux/slices/allianceSlice";
import { AllianceAPI } from "../apis/AllianceAPI";
import { Alliance, AllianceCreateEdit, Region } from "../types/slices/alliancesType";


export const useAllianceStore = () => {
  const dispatch = useDispatch();
  const {
    alliances,
    statusAlliances,
    editAlliance,
    selectedAlliance,
    openModal,
    isEdit,
    selectedRegion,
    regions,
  } = useSelector(selectAllianceState);

  const getAlliances = async () => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.getAlliances();
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchAlliances(detail));
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const getAlliancesSearch = async (term) => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.getAlliancesSearch(term);
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchAlliances(detail));
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const createAlliancestore = async (data: AllianceCreateEdit) => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.createAlliance(data);
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const editAlliancestore = async (id: number, data: AllianceCreateEdit) => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.editAlliance(id, data);
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const deleteAlliance = async (id: number) => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.deleteAlliance(id);
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        CustomSnackbar("error", response.data.message || "");
        return false;
      }
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
      CustomSnackbar("success", response.data.message || "");
      return true;
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const setSelectedAlliance = (alliance: Alliance) => {
    try {
      dispatch(onSetSelectedAlliance(alliance));
    } catch (error) {
      console.log(error);
    }
  };

  const setEditAlliance = (alliance: AllianceCreateEdit) => {
    try {
      dispatch(onSetEditAlliance(alliance));
    } catch (error) {
      console.log(error);
    }
  };

  const setOpenModal = (status: boolean) => {
    try {
      dispatch(onSetOpenModal(status));
    } catch (error) {
      console.log(error);
    }
  };

  const changeIsEdit = (status: boolean) => {
    try {
      dispatch(onChangeIsEdit(status));
    } catch (error) {
      console.log(error);
    }
  };

  const getRegions = async () => {
    try {
      dispatch(changeStatusAlliaces(ApiStatus.FETCHING));
      const response = await AllianceAPI.getRegions();
      if (!response?.status) {
        dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchRegions(detail));
      dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusAlliaces(ApiStatus.FETCHED));
    }
  };

  const setSelectedRegion = (region: Region) => {
    try {
      dispatch(onSetSelectedRegion(region));
    } catch (error) {
      console.log(error);
    }
  };

  return {
    // states
    alliances,
    statusAlliances,
    editAlliance,
    selectedAlliance,
    openModal,
    isEdit,
    selectedRegion,
    regions,
    // actions
    getAlliances,
    getAlliancesSearch,
    createAlliancestore,
    editAlliancestore,
    deleteAlliance,
    setOpenModal,
    setEditAlliance,
    setSelectedAlliance,
    changeIsEdit,
    getRegions,
    setSelectedRegion,
  };
};